module.exports = __webpack_public_path__ + "media/images/official/guide_room_reservation_2-07a6b1bd9327b5b453d107a069981b53.png";